import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const usePatientPrefill = () => {
  const patientData = useSelector((state) => state.patientData?.data);

  const prefillData = useMemo(() => {
    if (!patientData) return {};

    const result = {};

    if (patientData.firstName) {
      result.first_name = patientData.firstName;
    }
    if (patientData.lastName) {
      result.last_name = patientData.lastName;
    }
    if (patientData.email) {
      result.email = patientData.email;
    }

    return result;
  }, [patientData]);

  return prefillData;
};
